var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTeatro(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1769.33 374.92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#Degradado_sin_nombre_82-5);\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14, .cls-15, .cls-16, .cls-17, .cls-18, .cls-19, .cls-20, .cls-21, .cls-22, .cls-23, .cls-24, .cls-25, .cls-26, .cls-27, .cls-28, .cls-29, .cls-30, .cls-31, .cls-32, .cls-33, .cls-34, .cls-35, .cls-36, .cls-37, .cls-38, .cls-39, .cls-40, .cls-41, .cls-42, .cls-43, .cls-44, .cls-45, .cls-46, .cls-47, .cls-48, .cls-49 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: url(#Degradado_sin_nombre_5-4);\n      }\n\n      .cls-3 {\n        fill: url(#Degradado_sin_nombre_82);\n      }\n\n      .cls-4 {\n        fill: url(#Degradado_sin_nombre_7-5);\n      }\n\n      .cls-5 {\n        fill: url(#Degradado_sin_nombre_5-7);\n      }\n\n      .cls-6 {\n        fill: url(#Degradado_sin_nombre_7-3);\n      }\n\n      .cls-50 {\n        stroke: #551c0c;\n      }\n\n      .cls-50, .cls-51, .cls-19, .cls-52, .cls-53 {\n        fill: none;\n      }\n\n      .cls-50, .cls-51, .cls-52, .cls-53 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-7 {\n        fill: url(#Degradado_sin_nombre_33);\n      }\n\n      .cls-8 {\n        fill: url(#Degradado_sin_nombre_33-5);\n      }\n\n      .cls-9 {\n        fill: url(#Degradado_sin_nombre_7-2);\n      }\n\n      .cls-10 {\n        fill: url(#Degradado_sin_nombre_33-2);\n      }\n\n      .cls-11 {\n        fill: url(#Degradado_sin_nombre_47-6);\n      }\n\n      .cls-51 {\n        stroke: #cea328;\n      }\n\n      .cls-12 {\n        fill: url(#Degradado_sin_nombre_24-2);\n      }\n\n      .cls-13 {\n        fill: url(#Degradado_sin_nombre_82-6);\n      }\n\n      .cls-14 {\n        fill: url(#Degradado_sin_nombre_47-2);\n      }\n\n      .cls-54 {\n        isolation: isolate;\n      }\n\n      .cls-15 {\n        fill: url(#Degradado_sin_nombre_23-2);\n      }\n\n      .cls-16 {\n        fill: url(#Degradado_sin_nombre_82-2);\n      }\n\n      .cls-17 {\n        fill: url(#Degradado_sin_nombre_5-2);\n      }\n\n      .cls-18 {\n        fill: url(#Degradado_sin_nombre_27);\n      }\n\n      .cls-20 {\n        fill: url(#Degradado_sin_nombre_47-3);\n      }\n\n      .cls-52 {\n        stroke: #a17126;\n      }\n\n      .cls-21 {\n        fill: url(#Degradado_sin_nombre_5-3);\n      }\n\n      .cls-22 {\n        fill: url(#Degradado_sin_nombre_33-4);\n      }\n\n      .cls-23 {\n        fill: url(#Degradado_sin_nombre_82-3);\n      }\n\n      .cls-24 {\n        fill: url(#Degradado_sin_nombre_47-7);\n      }\n\n      .cls-25 {\n        fill: url(#Degradado_sin_nombre_5-8);\n      }\n\n      .cls-26 {\n        fill: url(#Degradado_sin_nombre_7-4);\n      }\n\n      .cls-27 {\n        fill: url(#Degradado_sin_nombre_47-5);\n      }\n\n      .cls-28 {\n        fill: url(#Degradado_sin_nombre_7-6);\n      }\n\n      .cls-29 {\n        fill: #fff;\n      }\n\n      .cls-30 {\n        fill: url(#Degradado_sin_nombre_29);\n      }\n\n      .cls-31 {\n        fill: url(#Degradado_sin_nombre_7);\n      }\n\n      .cls-32 {\n        fill: url(#Degradado_sin_nombre_82-8);\n      }\n\n      .cls-33 {\n        fill: url(#Degradado_sin_nombre_47);\n      }\n\n      .cls-34 {\n        fill: url(#Degradado_sin_nombre_82-7);\n      }\n\n      .cls-35 {\n        fill: url(#Degradado_sin_nombre_38);\n      }\n\n      .cls-36 {\n        fill: url(#Degradado_sin_nombre_5-5);\n      }\n\n      .cls-55 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-53 {\n        stroke: #72130a;\n      }\n\n      .cls-37 {\n        fill: url(#Degradado_sin_nombre_7-9);\n      }\n\n      .cls-38 {\n        fill: url(#Degradado_sin_nombre_33-3);\n      }\n\n      .cls-56 {\n        mix-blend-mode: multiply;\n        opacity: .22;\n      }\n\n      .cls-57 {\n        clip-path: url(#clippath-3);\n      }\n\n      .cls-58 {\n        fill: url(#Degradado_sin_nombre_24);\n      }\n\n      .cls-39 {\n        fill: url(#Degradado_sin_nombre_33-6);\n      }\n\n      .cls-40 {\n        fill: url(#Degradado_sin_nombre_7-8);\n      }\n\n      .cls-41 {\n        fill: url(#Degradado_sin_nombre_2);\n      }\n\n      .cls-42 {\n        fill: url(#Degradado_sin_nombre_33-7);\n      }\n\n      .cls-43 {\n        fill: url(#Degradado_sin_nombre_32);\n      }\n\n      .cls-44 {\n        fill: url(#Degradado_sin_nombre_7-7);\n      }\n\n      .cls-45 {\n        fill: url(#Degradado_sin_nombre_5);\n      }\n\n      .cls-46 {\n        fill: url(#Degradado_sin_nombre_5-6);\n      }\n\n      .cls-59 {\n        fill: url(#Degradado_sin_nombre_23);\n      }\n\n      .cls-47 {\n        fill: url(#Degradado_sin_nombre_82-4);\n      }\n\n      .cls-48 {\n        fill: url(#Degradado_sin_nombre_47-4);\n      }\n\n      .cls-49 {\n        fill: url(#Degradado_sin_nombre_77);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    width: 1769.33,
    height: 374.92
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_24",
    "data-name": "Degradado sin nombre 24",
    x1: 0,
    y1: 188.59,
    x2: 1251.51,
    y2: 188.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#72130a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#a43e19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#ac441c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_23",
    "data-name": "Degradado sin nombre 23",
    x1: 511.66,
    y1: 188.59,
    x2: 1769.33,
    y2: 188.59,
    gradientTransform: "translate(2280.99 377.18) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#ac441c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#7b1a0c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72130a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2",
    "data-name": "Degradado sin nombre 2",
    x1: 882.83,
    y1: 548.69,
    x2: 882.83,
    y2: 35.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b5a3a2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#c9bbb4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0ebd6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_47",
    "data-name": "Degradado sin nombre 47",
    x1: -2052.83,
    y1: 438.59,
    x2: -2052.83,
    y2: -47.96,
    gradientTransform: "translate(-944.75 377.18) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f0ebd6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b5a3a2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_47-2",
    "data-name": "Degradado sin nombre 47",
    x1: -2148.38,
    y1: 438.59,
    x2: -2148.38,
    xlinkHref: "#Degradado_sin_nombre_47"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_47-3",
    "data-name": "Degradado sin nombre 47",
    x1: -1956.27,
    x2: -1956.27,
    xlinkHref: "#Degradado_sin_nombre_47"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_47-4",
    "data-name": "Degradado sin nombre 47",
    x1: -1615.36,
    x2: -1615.36,
    xlinkHref: "#Degradado_sin_nombre_47"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_47-5",
    "data-name": "Degradado sin nombre 47",
    x1: -1728.24,
    x2: -1728.24,
    xlinkHref: "#Degradado_sin_nombre_47"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_47-6",
    "data-name": "Degradado sin nombre 47",
    x1: -1514.09,
    x2: -1514.09,
    xlinkHref: "#Degradado_sin_nombre_47"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_47-7",
    "data-name": "Degradado sin nombre 47",
    x1: -1849.44,
    x2: -1849.44,
    xlinkHref: "#Degradado_sin_nombre_47"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    y: -61.41,
    width: 1769.33,
    height: 500
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_24-2",
    "data-name": "Degradado sin nombre 24",
    x1: 489.71,
    y1: 75.6,
    x2: 660.35,
    y2: 246.24,
    xlinkHref: "#Degradado_sin_nombre_24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_32",
    "data-name": "Degradado sin nombre 32",
    x1: 507.83,
    y1: 232.36,
    x2: 537.61,
    y2: 232.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cea328"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#ddc135"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_23-2",
    "data-name": "Degradado sin nombre 23",
    x1: 1106.61,
    y1: 244.94,
    x2: 1277.25,
    y2: 74.29,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#Degradado_sin_nombre_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_29",
    "data-name": "Degradado sin nombre 29",
    x1: 1228.05,
    y1: 232.36,
    x2: 1257.83,
    y2: 232.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#ddc135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cea328"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_27",
    "data-name": "Degradado sin nombre 27",
    x1: 882.83,
    y1: 70.43,
    x2: 882.83,
    y2: -52.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#551c0c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#261512"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_33",
    "data-name": "Degradado sin nombre 33",
    x1: 632.6,
    y1: 397.47,
    x2: 632.6,
    y2: 316.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#72130a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72130a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_5",
    "data-name": "Degradado sin nombre 5",
    x1: 632.6,
    y1: 397.47,
    x2: 632.6,
    y2: 327.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#261512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3f0606"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_33-2",
    "data-name": "Degradado sin nombre 33",
    x1: 732.69,
    x2: 732.69,
    xlinkHref: "#Degradado_sin_nombre_33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_5-2",
    "data-name": "Degradado sin nombre 5",
    x1: 732.69,
    x2: 732.69,
    xlinkHref: "#Degradado_sin_nombre_5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_33-3",
    "data-name": "Degradado sin nombre 33",
    x1: 532.51,
    x2: 532.51,
    xlinkHref: "#Degradado_sin_nombre_33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_5-3",
    "data-name": "Degradado sin nombre 5",
    x1: 532.51,
    x2: 532.51,
    xlinkHref: "#Degradado_sin_nombre_5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_33-4",
    "data-name": "Degradado sin nombre 33",
    x1: 832.78,
    x2: 832.78,
    xlinkHref: "#Degradado_sin_nombre_33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_5-4",
    "data-name": "Degradado sin nombre 5",
    x1: 832.78,
    x2: 832.78,
    xlinkHref: "#Degradado_sin_nombre_5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_33-5",
    "data-name": "Degradado sin nombre 33",
    x1: 932.87,
    x2: 932.87,
    xlinkHref: "#Degradado_sin_nombre_33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_5-5",
    "data-name": "Degradado sin nombre 5",
    x1: 932.87,
    x2: 932.87,
    xlinkHref: "#Degradado_sin_nombre_5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_38",
    "data-name": "Degradado sin nombre 38",
    x1: 1032.96,
    y1: 397.47,
    x2: 1032.96,
    y2: 316.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#72130a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72130a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_5-6",
    "data-name": "Degradado sin nombre 5",
    x1: 1032.96,
    x2: 1032.96,
    xlinkHref: "#Degradado_sin_nombre_5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_33-6",
    "data-name": "Degradado sin nombre 33",
    x1: 1133.05,
    x2: 1133.05,
    xlinkHref: "#Degradado_sin_nombre_33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_5-7",
    "data-name": "Degradado sin nombre 5",
    x1: 1133.05,
    x2: 1133.05,
    xlinkHref: "#Degradado_sin_nombre_5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_33-7",
    "data-name": "Degradado sin nombre 33",
    x1: 1233.14,
    x2: 1233.14,
    xlinkHref: "#Degradado_sin_nombre_33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_5-8",
    "data-name": "Degradado sin nombre 5",
    x1: 1233.14,
    x2: 1233.14,
    xlinkHref: "#Degradado_sin_nombre_5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_7",
    "data-name": "Degradado sin nombre 7",
    x1: 782.74,
    y1: 430.87,
    x2: 782.74,
    y2: 337.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#72130a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#a43e19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ac441c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_82",
    "data-name": "Degradado sin nombre 82",
    x1: 782.74,
    y1: 438.59,
    x2: 782.74,
    y2: 356.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#261512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#551c0c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_7-2",
    "data-name": "Degradado sin nombre 7",
    x1: 682.65,
    y1: 429.82,
    x2: 682.65,
    y2: 336.84,
    xlinkHref: "#Degradado_sin_nombre_7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_82-2",
    "data-name": "Degradado sin nombre 82",
    x1: 682.65,
    x2: 682.65,
    xlinkHref: "#Degradado_sin_nombre_82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_7-3",
    "data-name": "Degradado sin nombre 7",
    x1: 582.56,
    y1: 430.16,
    x2: 582.56,
    y2: 337.17,
    xlinkHref: "#Degradado_sin_nombre_7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_82-3",
    "data-name": "Degradado sin nombre 82",
    x1: 582.56,
    x2: 582.56,
    xlinkHref: "#Degradado_sin_nombre_82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_7-4",
    "data-name": "Degradado sin nombre 7",
    x1: 482.47,
    y1: 438.59,
    x2: 482.47,
    y2: 345.61,
    xlinkHref: "#Degradado_sin_nombre_7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_82-4",
    "data-name": "Degradado sin nombre 82",
    x1: 482.47,
    x2: 482.47,
    xlinkHref: "#Degradado_sin_nombre_82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_7-5",
    "data-name": "Degradado sin nombre 7",
    x1: 882.8,
    y1: 429.64,
    x2: 882.8,
    y2: 336.66,
    xlinkHref: "#Degradado_sin_nombre_7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_82-5",
    "data-name": "Degradado sin nombre 82",
    x1: 882.8,
    x2: 882.8,
    xlinkHref: "#Degradado_sin_nombre_82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_7-6",
    "data-name": "Degradado sin nombre 7",
    x1: 982.92,
    y1: 429.89,
    x2: 982.92,
    y2: 336.91,
    xlinkHref: "#Degradado_sin_nombre_7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_82-6",
    "data-name": "Degradado sin nombre 82",
    x1: 982.92,
    x2: 982.92,
    xlinkHref: "#Degradado_sin_nombre_82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_7-7",
    "data-name": "Degradado sin nombre 7",
    x1: 1083,
    y1: 431.27,
    x2: 1083,
    y2: 338.29,
    xlinkHref: "#Degradado_sin_nombre_7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_82-7",
    "data-name": "Degradado sin nombre 82",
    x1: 1083,
    x2: 1083,
    xlinkHref: "#Degradado_sin_nombre_82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_7-8",
    "data-name": "Degradado sin nombre 7",
    x1: 1183.1,
    y1: 431.77,
    x2: 1183.1,
    y2: 338.79,
    xlinkHref: "#Degradado_sin_nombre_7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_82-8",
    "data-name": "Degradado sin nombre 82",
    x1: 1183.1,
    x2: 1183.1,
    xlinkHref: "#Degradado_sin_nombre_82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_7-9",
    "data-name": "Degradado sin nombre 7",
    x1: 1283.19,
    y1: 438.59,
    x2: 1283.19,
    y2: 345.61,
    xlinkHref: "#Degradado_sin_nombre_7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_77",
    "data-name": "Degradado sin nombre 77",
    x1: 1283.19,
    y1: 438.59,
    x2: 1283.19,
    y2: 356.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#261512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#58130c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72130a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "TEXTURE"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-55"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    y: -61.41,
    width: 1251.51,
    height: 500
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 511.66,
    y: -61.41,
    width: 1257.68,
    height: 500,
    transform: "translate(2280.99 377.18) rotate(180)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 507.83,
    y: -61.41,
    width: 750,
    height: 500
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 507.83,
    y: -61.41,
    width: 750,
    height: 500
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-56"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "1098.01 -61.41 1130.39 -61.41 1127.5 425.14 1085.78 425.14 1098.01 -61.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "1199.51 -61.41 1231.32 -61.41 1228.09 425.14 1175.95 425.14 1199.51 -61.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "985.27 -61.41 1020.92 -61.41 1037.78 425.14 991.84 425.14 985.27 -61.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-48",
    points: "657.72 -61.41 686.18 -61.41 693.35 425.14 647.88 425.14 657.72 -61.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "773.05 -61.41 811.17 -61.41 808.5 425.14 755.82 425.14 773.05 -61.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "542.28 -61.41 567.8 -61.41 596.41 425.14 550.46 425.14 542.28 -61.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "877.62 -61.41 915.98 -61.41 932.84 425.14 876.55 425.14 877.62 -61.41"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-57"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m552.31,377.42c.6-47.13-5.19-94.52-19.57-139.4,62.35-21.73,116.89-63.1,159.21-113.79,20.56-24.62,38.44-51.49,53.2-79.98l-103.84-14.33-133.49,50.69v299.89l44.48-3.09Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "m507.83,225.28v7.43s13.31,4.87,25.37,6.73c0,0,4-.41,4.4-3.16.4-2.74-12.38-8.69-29.77-11Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "m540.85,213.89c45.52-22.31,83.51-57.4,117.99-94.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "m554.03,102.08c-6.71,32.97-17.79,65.05-32.85,95.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "m526.42,250.19c6.01,29.84,9.75,60.13,11.19,90.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "m532.75,199.69c22.67-28.26,49.09-72.17,67.09-117.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "m581.85,162.02c11.9-4.16,22.08-13.05,27.79-24.29.87-1.71,1.65-3.64,1.16-5.49-.49-1.85-2.86-3.24-4.39-2.09-.61,1.35.24,3.01,1.52,3.76,1.28.75,2.84.8,4.32.71,14.21-.83,26.76-13.44,27.52-27.65"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m1213.34,377.42c-.6-47.13,5.19-94.52,19.57-139.4-62.35-21.73-116.89-63.1-159.21-113.79-20.56-24.62-38.44-51.49-53.2-79.98l103.84-14.33,133.49,50.69v299.89l-44.48-3.09Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m1257.83,225.28v7.43s-13.31,4.87-25.37,6.73c0,0-4-.41-4.4-3.16-.4-2.74,12.38-8.69,29.77-11Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "m1224.8,213.89c-45.52-22.31-111.64-72.71-142.02-131.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "m1212.97,117.79c6.28,20.63,14.29,40.73,23.94,60.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "m1242.51,245.93c-6.01,29.84-11.19,81.29-11.19,111.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "m1232.9,199.69c-22.67-28.26-41.7-59.43-56.47-92.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "m1183.81,162.02c-11.9-4.16-22.08-13.05-27.79-24.29-.87-1.71-1.65-3.64-1.16-5.49.49-1.85,2.86-3.24,4.39-2.09.61,1.35-.24,3.01-1.52,3.76-1.28.75-2.84.8-4.32.71-14.21-.83-26.76-13.44-27.52-27.65"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m509.26,92.35c-.64,4.32-.92,8.68-.84,13.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m511.87,91.85c.25,4.45.25,8.92,0,13.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m514.11,92.67c.4,4.34.42,8.71.06,13.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m517,92.02c.13,4.07.26,8.15.38,12.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m520.63,91.85c.14,4.55.01,9.12-.39,13.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m523.71,91.4c.55,4.16.5,8.4-.16,12.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m526.29,90.97c.05,4.22.21,8.45.48,12.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m528.98,91.29c.53,4.38.57,8.82.13,13.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m532.1,90.97c.75,4.59.6,9.33-.44,13.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m535.51,90.42c.15,4.4.3,8.81.46,13.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m538.56,89.87c.09,4.48.17,8.95.26,13.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m542.3,89.87c.5,4.17.38,8.42-.33,12.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m545.77,88.99c-.19,4.55.23,9.12,1.26,13.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m548.74,88.88c.04,4.07.08,8.15.12,12.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m552.16,87.33c.47,4.31.42,8.69-.15,12.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m554.88,86.9c.86,4.69.74,9.55-.33,14.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m557.79,86.45c.06,4.15.12,8.29.19,12.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m560.6,86.02c.95,4.29,1.08,8.76.4,13.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m563.79,85.34c.53,4.46.67,8.96.42,13.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m566.65,84.26c.49,4.33.97,8.66,1.46,12.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m569.41,83.26c.28,4.23,1.11,8.42,2.44,12.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m573.2,82.27c1.04,4.73,1.22,9.65.53,14.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m576.49,80.96c.65,4.57.42,9.27-.65,13.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m578.97,80.4c.43,4.15.86,8.3,1.28,12.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m581.42,78.86c-.14,3.98.58,7.99,2.08,11.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m584.4,77.46c1.04,3.93,1.46,8.02,1.24,12.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m587.59,76.22c1.42,4.72,1.68,9.79.74,14.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m589.82,74.67c.17,4.08,1.04,8.12,2.54,11.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m592.76,73.14c1.32,4.11,1.88,8.46,1.64,12.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m595.81,71.28c1.7,4.23,2.26,8.91,1.63,13.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m599.48,69.39c1.3,4.68,1.58,9.64.81,14.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m602.37,67.63c-.29,4.48.16,9.01,1.33,13.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m604.7,66.63c.76,4.8.89,9.7.4,14.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m606.55,64.32c1.05,5.02,1.27,10.22.64,15.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m609.83,61.8c-.14,4.8.29,9.62,1.3,14.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m612.3,60.59c.39,4.67.95,9.33,1.67,13.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m615.27,58.26c.97,4.85,1.29,9.83.93,14.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m618.57,55.51c-.56,5.04-.15,10.19,1.23,15.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m620.93,53.21c.22,4.23.84,8.44,1.88,12.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m623.25,51.56c1.48,4.83,2.02,9.94,1.59,14.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m626.02,48.36c1.43,5.44,1.8,11.16,1.09,16.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m628.79,45.39c-.56,5.8-.31,11.67.74,17.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m630.82,42.09c.36,5.28,1.23,10.52,2.6,15.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m633.1,39.88c1.42,5.64,2.06,11.48,1.89,17.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m635.66,37.15c1.65,5.66,2.33,11.6,2,17.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m638.85,33.72c.24,6.17.67,12.34,1.28,18.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m642.97,36.8c.05,5.82.45,11.63,1.2,17.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m647.25,39.01c-.26,5.32-.16,10.66.32,15.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m649.88,41.32c.49,4.75.97,9.64-.38,14.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m653.34,43.19c-.27,5.1-.21,10.21.16,15.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m655.77,44.41c.74,5.39,1.47,10.98-.12,16.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m659.29,46.6c-.05,4.97-.36,9.93-.94,14.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m661.73,48.04c-.38,4.91.06,9.89,1.32,14.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m665.49,49.36c.54,4.79.52,9.64-.04,14.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m668.74,50.35c-.25,4.95-.36,9.91-.33,14.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m671.77,50.91c1.13,4.49,1.24,9.23.32,13.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m675.62,53.1c.01,4.52-.23,9.05-.71,13.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m679.78,54.32c-.03.69-.07,1.38-.1,2.07-.18,3.74-.32,7.69,1.44,10.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m683.33,54.97c.28,4.52.05,9.08-.69,13.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m686.19,54.97c.5,4.67.14,9.43-1.06,13.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m688.33,54.86c.29,4.66.57,9.32.86,13.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m692.89,56.3c.56,4.32.36,8.74-.59,12.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m695.69,56.29c.65,4.44.35,9.01-.88,13.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m698.25,56.95c-.1,4.59-.04,9.18.18,13.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m702.06,57.29c.02,1.36.03,2.72.05,4.08.04,3.13.07,6.3-.63,9.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m705.44,57.07c-.34,4.74-.1,9.53.73,14.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m708.25,57.5c-.39,3.99.01,8.06,1.18,11.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m710.67,56.84c-.16,4.32.48,8.67,1.89,12.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m714.41,56.64c.61,4.34.6,8.76-.05,13.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m717.31,56.62c.25,4.58.49,9.26-.79,13.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m720.42,56.19c.5,4.59.19,9.28-.91,13.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m723.43,55.19c-.26,4.59-.03,9.22.68,13.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m726.29,54.86c.42,4.61.43,9.26.03,13.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m729.65,54.32c.78,4.84.75,9.81-.1,14.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m732.78,53.54c.21,4.27.62,8.54,1.25,12.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m736.06,52.55c.21,4.18.21,8.37-.01,12.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m738.75,51.89c.74,4.7.75,9.51.02,14.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m741.32,50.69c.98,4.13,1.29,8.42.9,12.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m744.37,49.02c-.04,3.8-.09,7.62.42,11.39.17,1.28.42,2.59,1.09,3.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m747.16,48.25c-.32,4.59-.07,9.23.75,13.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m750.01,47.5c.82,4.79.95,9.7.4,14.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m752.57,45.83c.22,4.7.21,9.4-.05,14.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m754.76,44.5c.92,4.86,1.04,9.87.34,14.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m757.72,43.19c-.11,5.11-.18,10.39,1.74,15.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m760.37,41.65c-.18,4.73.49,9.48,1.98,13.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m763.34,39.89c.55,5.05.52,10.15-.09,15.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m765.82,38.24c.54,4.97.53,10.01-.05,14.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m767.98,36.04c1.18,5.28,1.14,10.82-.11,16.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m770.78,35.26c-.24,4.44-.44,9.08,1.39,13.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m772.34,33.72c-.19,4.33.63,8.7,2.37,12.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m775.52,31.08c.74,5.25.88,10.58.42,15.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m778.17,28.43c1.4,5.26,1.83,10.78,1.25,16.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m781.47,25.47c-.4,5.06-.34,10.15.2,15.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m783.06,23.37c-.16,5.56-.31,11.25,1.44,16.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m784.78,21.62c.51,5.67.65,11.37.41,17.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m787.97,18.9c.49,6.19.3,12.44-.57,18.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m789.58,16.3c1.48,5.89,2.11,11.99,1.86,18.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m793.21,15.24c-.47,6.55-.37,13.13.29,19.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m796.01,18.46c-.13,5.34-.03,10.68.29,16.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m799.09,21.04c-.42,5.65-.45,11.33-.09,16.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m801.69,23.3c.25,5.25-.1,10.52-1.05,15.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m803.72,25.23c.76,5.09.31,10.36-1.29,15.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m806.19,27.59c-.31,4.61-.41,9.24-.3,13.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m808.79,29.51c-.97,4.66-.71,9.57.74,14.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m811.01,31.71c1.16,4.69,1.27,9.64.31,14.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m813.72,32.97c1.02,4.96.84,10.17-.51,15.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m817.08,34.05c-.53,5.14-.52,10.34.01,15.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m819.54,36.53c.64,4.64.44,9.4-.59,13.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m823.19,38.66c.28,4.14-.05,8.32-.96,12.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m826.42,40.37c-.67,4.68-.56,9.46.34,14.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m829.15,42.42c-.58,4.46-.58,8.99.01,13.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m831.85,43.93c.28,4.28-.04,8.59-.93,12.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m834.19,44.89c.14,4.18.27,8.45-.95,12.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m836.39,46.08c-.38,4.11-.66,8.23-.85,12.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m838.12,45.97c-.05,4.59.2,9.19.74,13.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m840.7,47.38c.77,4.4.72,8.94-.15,13.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m842.71,47.91c.56,4.6.42,9.29-.42,13.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m845,49.19c.73,4.12.63,8.39-.3,12.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m848.41,49.84c-.66,4.45-.58,9.01.24,13.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m851.01,51.66c-.06,4.19-.13,8.38-.19,12.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m853.34,51.34c.33,4.55.21,9.13-.37,13.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m856.79,52.09c.22,4.99-.09,10.01-.94,14.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m859.21,52.74c-.11,4.53-.46,9.04-1.05,13.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m861.82,53.81c-.32,4.51-.47,9.02-.43,13.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m863.52,54.14c0,4.17.26,8.33.8,12.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m866.72,54.68c.56,4.14.42,8.37-.4,12.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m869.26,54.23c.82,4.57,1.1,9.24.83,13.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m872.59,55.53c-.29,4.69-.32,9.39-.07,14.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m875.37,55.64c-.33,4.19-.21,8.41.37,12.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m877.4,55.86c.23,4.37.13,8.76-.29,13.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m880.67,56.08c.33,4.54-.09,9.14-1.25,13.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m883.52,56.18c.51,4.39.68,9.08-1.37,13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m886.45,56.18c.78,4.4.21,9.02-1.61,13.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m888.99,55.65c-.53,4.63-.24,9.35.86,13.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m891.6,55.21c-.23,4.19.2,8.42,1.27,12.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m894.29,55.32c.58,3.7.5,7.51-.24,11.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m896.93,54.99c.58,4.61.34,9.33-.7,13.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m899.62,54.79c.39,2.17.23,4.4.26,6.6.04,2.21.3,4.49,1.45,6.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m902.55,53.6c.12,4.37.08,8.75-.12,13.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m905.75,53.28c.27,4.27.51,8.69-.94,12.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m907.64,52.63c1.03,4.49.83,9.25-.56,13.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m910.58,51.87c.34,4.16.69,8.31,1.03,12.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m913.61,51.67c.57,4.28.54,8.63-.1,12.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m916.85,50.06c.63,4.39.38,9.77-.66,14.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m919.79,48.98c-.38,4.63-.15,9.3.7,13.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m922.62,48.33c-.14,4.68-.26,9.51,1.43,13.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m925.52,47.26c.2,2.31-.02,4.64.05,6.95.07,2.32.48,4.71,1.79,6.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m928.78,45.76c.69,4.37.68,8.85-.02,13.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m931.46,44.9c.25,4.16.01,8.36-.7,12.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m933.38,43.4c1.17,4.78,1.14,9.85-.11,14.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m936.63,42.53c-.48,4.63-.19,9.33.86,13.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m938.95,40.5c.42,3.31.83,6.63.72,9.96-.05,1.48-.22,2.99-.84,4.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m941.94,38.66c.75,4.8.72,9.72-.07,14.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m945.03,37.48c-.27,3.68-.14,7.39.4,11.04.19,1.26.44,2.56,1.17,3.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m948.1,34.91c.72,5.01.79,10.12.21,15.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m950.78,32.97c.79,5.14.57,10.43-.62,15.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m953.68,32.04c.69,4.78.46,10.51-.6,15.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m956.28,30.17c-.59,5.11-.44,10.3.43,15.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m959.11,27.57c-.85,5.24-.01,10.58.82,15.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m962,24.7c.45,5.77.91,11.62-.12,17.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m965.25,23.19c-.19,5.59-.02,11.19.49,16.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m968.37,19.32c-.19,6.09.02,12.2.62,18.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m971.45,16.4c1.11,6.36,1.02,12.92-.26,19.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m975.04,16.31c.29,6.62-.28,13.28-1.69,19.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m978.88,19.53c-.52,6.2-1.04,12.4-1.56,18.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m981.31,23.29c-.64,5.96-.83,11.96-.57,17.95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m983.45,25.78c1,5.5.9,11.2-.28,16.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m985.87,28.24c.52,4.58,1.03,9.25.13,13.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m989.46,30.07c-.66,5.46-1.2,10.94-1.6,16.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m991.43,32.97c-.02,5.09-.03,10.17-.05,15.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m995.15,34.46c-.9,5.67-1.68,11.61.15,17.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m998.14,36.52c.71,4.89.53,9.9-.52,14.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m1000.44,38.45c.91,4.75.78,9.7-.37,14.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m1003.32,40.81c.64,5.01.09,10.17-1.59,14.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m1007.04,42.85c-.59,4.74-.6,9.55-.04,14.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m1010.08,43.92c-.66,4.73-.66,9.56,0,14.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m1012.59,45.76c.41,5.09.17,10.23-.7,15.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m1014.58,46.83c.45,5.2.1,10.48-1.02,15.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m1017.22,48.23c.48,4.68-.15,9.46-1.83,13.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m1020.01,48.98c-.54,4.6-.61,9.25-.21,13.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m1022.6,50.16c.65,4.13.58,8.36-.21,12.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m1025.08,50.48c.65,4.81.53,9.73-.34,14.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m1028.95,51.77c-.99,4.69-1.04,9.58-.13,14.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m1031.33,52.52c.32,4.81.03,9.66-.87,14.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m1033.98,53.28c.55,4.53.1,9.18-1.29,13.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m1037.06,53.82c-.25,4.94-.23,9.89.08,14.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m1040.1,55.19c-.35.64-.37,1.4-.37,2.13l-.11,11.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m1042.77,55.43c.63,4.52.29,9.17-1.01,13.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m1045.56,56.61c.46,4.52.19,9.11-.79,13.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m1049.1,55.75c.61,4.61.11,9.37-1.43,13.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m1051.81,56.82c-.05,4.76-.11,9.53-.16,14.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m1054.83,55.85c-.2,4.87-.26,9.74-.18,14.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m1057.97,56.39c.05,4.38.26,8.75.64,13.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m1061.92,56.18c.49,4.55,0,9.2-1.46,13.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m1063.83,57.34c.77,3.76.59,7.72-.54,11.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m1067.13,56.72c-.81,4.97-.47,10.12.98,14.95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m1069.95,56.92c-.88,4.06-.52,8.39,1.03,12.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m1073.04,56.3c.62,4.23.63,8.55.03,12.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m1076.08,54.78c.47,4.61.35,9.28-.38,13.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m1078.86,54.46c.57,4.24,1.1,8.71-.52,12.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m1082.47,54.03c-.62,4.46-.44,9.03.52,13.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m1085.08,53.59c-.55,4.34-.26,8.78.84,13.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m1087.97,52.22c.74,4.3.61,8.75-.38,13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m1090.92,52.53c.85,4.62.66,9.44-.57,13.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m1093.98,51.98c.33,2.34.67,4.69.62,7.05-.04,2.36-.48,4.75-1.6,6.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m1097.02,50.15c1.08,4.42.85,9.16-.66,13.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m1099.78,49.19c-.16,4.59.08,9.2.72,13.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m1102.43,48.12c-.82,4.56-.56,9.32.76,13.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m1105.2,46.19c.76,5,.46,10.17-.89,15.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m1108.21,44.04c.62,5.1.24,10.31-1.11,15.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m1111.52,43.61c.31,5.44.59,11.11-1.56,16.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m1113.73,41.99c-.39,5.13.2,10.34,1.71,15.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m1116.26,40.92c.36,5.08.26,10.2-.32,15.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m1119.06,39.31c.55,5.33.02,10.78-1.56,15.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m1121.95,38.13c.93,5.54.56,11.29-1.06,16.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m1125.55,34.04c-.21,5.97-.78,11.94-1.72,17.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m1127.49,34.79c-.59,5.97-.45,12.01.39,17.95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m1130.29,38.34c-.39,5.83-.4,11.68-.03,17.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m1132.98,41.89c-.11,5.95-.22,11.89-.32,17.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m1135.6,43.93c.86,5.81.74,11.76-.37,17.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m1138.95,47.37c.43,5.71.04,11.48-1.13,17.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m1141.88,51.02c.28,5.3.1,10.63-.54,15.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m1145.54,52.84c-.36,6.01-.52,12.04-.5,18.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m1148.88,57.46c-.54,4.85-.67,9.75-.4,14.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m1152.28,59.72c-.46,4.68-.65,10.56-.49,15.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m1156.3,62.52c-.15,4.45-.61,11.26-.05,15.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m1159.11,64.66c.64,4.49.45,10.66-.46,15.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m1161.96,67.14c.9,4.47-.1,9.08-1.1,13.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m1164.83,68.31c.37,4.47.3,8.98-.23,13.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m1167.5,70.79l-.38,13.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m1170.04,72.08c.48,4.79.32,10.61-.41,15.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m1172.72,73.58c.77,4.63.59,9.41-.52,13.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m1176.44,74.34c-.38,6.16-.26,12.35.35,18.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m1180.13,76.7c.31,5.02.06,10.08-.75,15.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m1184.04,77.34c.77,4.54.42,9.27-1.01,13.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m1187.59,79.71c.28,4.43-.37,8.93-1.91,13.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m1190.6,80.68c-.68,4.26-.84,8.6-.48,12.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m1193.24,81.86c-.19,4.83-.24,9.67-.14,14.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m1196.53,83.58c.45,2.91.58,5.88.39,8.82-.09,1.41-.27,2.85-.96,4.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m1199.78,84.55c.58,4.55.26,9.22-.95,13.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m1203.77,85.19c-.82,1.73-.43,4.18-.43,6.02,0,2.87-.1,5.73-.11,8.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m1206.33,85.08c-.26,5.26-.29,10.53-.1,15.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m1209.54,86.37c.28,4.91.05,9.86-.68,14.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m1213.74,87.56c.74,4.98.3,10.14-1.29,14.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m1218.34,88.3c-.31,5.38-.08,10.79.69,16.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m1221.61,89.38c.2,4.89-.18,9.8-1.13,14.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m1224.62,89.92c.44,4.38.14,8.83-.9,13.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m1229.2,90.67c-.13,2.6-.21,5.21-.23,7.81-.02,2.19.01,4.44.78,6.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m1233.39,90.67c.32,4.32-.02,8.68-1.01,12.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m1236.63,90.45c.21,4.36.37,8.9-1.42,12.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m1239.95,91.21c.42,4.63-.16,9.35-1.67,13.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m1243.17,90.88c-.34,4.86-.49,9.74-.44,14.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m1246.52,91.31c-.21,4.62-.1,9.26.32,13.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m1249.8,91.74c.49,5,.39,10.06-.28,15.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m1252.91,91.64c.28,4.91-.25,9.87-1.59,14.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m1255.59,91.85c-.11,4.44-.05,8.89.17,13.32"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m507.83,92.46c47,.94,96.94-13.36,129.97-57.83,22.63,17.34,52.53,25.5,80.81,21.85,28.28-3.64,54.9-18.85,72.4-41.36,0,0,38.23,40.91,91.83,40.91s90.93-40.91,90.93-40.91c17.5,22.51,44.12,37.72,72.4,41.36,28.28,3.64,58.17-4.51,80.81-21.85,33.03,44.48,83.86,58.7,130.86,57.76V-1.41H507.83v93.86Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "m632.8,1.71c.2,10.05,1.61,20.07,4.19,29.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "m790.82,1.04c-.09,3.97.08,7.95.5,11.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "m973.11,1.71c-.02,3.85.13,7.71.44,11.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "m1135.12,2.04c-.13,10.56-2.45,21.08-6.76,30.71"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "m645.81,20.23c3.67,3.7,8.51,6,13.38,7.86,19.39,7.45,40.97,9.07,61.26,4.61,20.29-4.46,39.2-14.99,53.67-29.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "m661.68,5.35c3.18,3.85,8.11,5.74,12.92,7.08,23.26,6.48,49.06,3.31,70.07-8.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m740.91,39.92c17.27-7.56,32.15-20.48,42.05-36.53"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "m806.5,5.63c10.52,7.05,21.79,12.99,33.55,17.69,4.31,1.72,8.68,3.27,13.14,4.55,35.59,10.17,76.11.9,103.74-23.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "m833.53,4.84c28.21,13.02,62.11,13.05,90.35.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m895.86,42.74c25.98-4.5,50.35-17.82,68.17-37.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m813.95,21.5c10.79,8.35,23.37,14.37,36.65,17.52"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "m983.94,11.74c19.88,14.28,43.86,22.78,68.3,24.19,24.44,1.41,49.24-4.26,70.63-16.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "m1007.55,5.69c33.36,19.41,75.86,19.78,111.74,5.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m1079.1,44.8c16.42-1.42,30.88-10.93,44.54-20.15"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m1140.57,19.04c8.86,18.61,24.58,33.55,42.88,43.04,18.3,9.49,39.05,13.72,59.66,13.94,3.85.04,7.77-.06,11.42-1.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "m1151.91,12.48c26.43,22.64,62,34.28,96.7,31.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "m1178.04,13.72c21.05,8.71,45.13,9.9,66.94,3.3"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m624.97,18.73c-21.92,25.29-54.77,40.76-88.23,41.56-6.1.15-12.63-.31-17.54-3.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "m618.2,8.91c-24.29,20.2-56.35,30.8-87.9,29.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "m521.15,19.42c24.06,6.17,50.33,3.29,72.48-7.95"
  }))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m680.16,397.47c-1.12-11.94-2.24-30.09-3.37-42.02-.92-9.82-1.97-20.02-7-28.42-2.37-3.95-5.72-7.47-9.98-9.01-3.25-1.18-6.78-1.14-10.23-1.09-5.2.08-11.78-.1-16.98-.02-5.2-.08-11.78.1-16.98.02-3.45-.05-6.98-.09-10.23,1.09-4.26,1.55-7.61,5.07-9.98,9.01-5.03,8.4-6.08,18.6-7,28.42-1.12,11.94-2.24,30.09-3.37,42.02h95.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "m587.82,397.47c1.06-11.24,2.11-22.47,3.17-33.71.87-9.24,1.85-18.85,6.59-26.76,2.23-3.72,5.38-7.03,9.39-8.49,3.06-1.11,6.39-1.07,9.63-1.02,4.9.08,11.09-.09,15.99-.02,4.9-.08,11.09.09,15.99.02,3.25-.05,6.57-.09,9.63,1.02,4.01,1.46,7.16,4.77,9.39,8.49,4.74,7.91,5.72,17.51,6.59,26.76,1.06,11.24,2.11,22.47,3.17,33.71h-89.55Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m780.25,397.47c-1.12-11.94-2.24-30.09-3.37-42.02-.92-9.82-1.97-20.02-7-28.42-2.37-3.95-5.72-7.47-9.98-9.01-3.25-1.18-6.78-1.14-10.23-1.09-5.2.08-11.78-.1-16.98-.02-5.2-.08-11.78.1-16.98.02-3.45-.05-6.98-.09-10.23,1.09-4.26,1.55-7.61,5.07-9.98,9.01-5.03,8.4-6.08,18.6-7,28.42-1.12,11.94-2.24,30.09-3.37,42.02h95.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m687.91,397.47c1.06-11.24,2.11-22.47,3.17-33.71.87-9.24,1.85-18.85,6.59-26.76,2.23-3.72,5.38-7.03,9.39-8.49,3.06-1.11,6.39-1.07,9.63-1.02,4.9.08,11.09-.09,15.99-.02,4.9-.08,11.09.09,15.99.02,3.25-.05,6.57-.09,9.63,1.02,4.01,1.46,7.16,4.77,9.39,8.49,4.74,7.91,5.72,17.51,6.59,26.76,1.06,11.24,2.11,22.47,3.17,33.71h-89.55Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "m580.07,397.47c-1.12-11.94-2.24-30.09-3.37-42.02-.92-9.82-1.97-20.02-7-28.42-2.37-3.95-5.72-7.47-9.98-9.01-3.25-1.18-6.78-1.14-10.23-1.09-5.2.08-11.78-.1-16.98-.02-5.2-.08-11.78.1-16.98.02-3.45-.05-6.98-.09-10.23,1.09-4.26,1.55-7.61,5.07-9.98,9.01-5.03,8.4-6.08,18.6-7,28.42-1.12,11.94-2.24,30.09-3.37,42.02h95.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m487.73,397.47c1.06-11.24,2.11-22.47,3.17-33.71.87-9.24,1.85-18.85,6.59-26.76,2.23-3.72,5.38-7.03,9.39-8.49,3.06-1.11,6.39-1.07,9.63-1.02,4.9.08,11.09-.09,15.99-.02,4.9-.08,11.09.09,15.99.02,3.25-.05,6.57-.09,9.63,1.02,4.01,1.46,7.16,4.77,9.39,8.49,4.74,7.91,5.72,17.51,6.59,26.76,1.06,11.24,2.11,22.47,3.17,33.71h-89.55Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m880.34,397.47c-1.12-11.94-2.24-30.09-3.37-42.02-.92-9.82-1.97-20.02-7-28.42-2.37-3.95-5.72-7.47-9.98-9.01-3.25-1.18-6.78-1.14-10.23-1.09-5.2.08-11.78-.1-16.98-.02-5.2-.08-11.78.1-16.98.02-3.45-.05-6.98-.09-10.23,1.09-4.26,1.55-7.61,5.07-9.98,9.01-5.03,8.4-6.08,18.6-7,28.42-1.12,11.94-2.24,30.09-3.37,42.02h95.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m788,397.47c1.06-11.24,2.11-22.47,3.17-33.71.87-9.24,1.85-18.85,6.59-26.76,2.23-3.72,5.38-7.03,9.39-8.49,3.06-1.11,6.39-1.07,9.63-1.02,4.9.08,11.09-.09,15.99-.02,4.9-.08,11.09.09,15.99.02,3.25-.05,6.57-.09,9.63,1.02,4.01,1.46,7.16,4.77,9.39,8.49,4.74,7.91,5.72,17.51,6.59,26.76,1.06,11.24,2.11,22.47,3.17,33.71h-89.55Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m980.43,397.47c-1.12-11.94-2.24-30.09-3.37-42.02-.92-9.82-1.97-20.02-7-28.42-2.37-3.95-5.72-7.47-9.98-9.01-3.25-1.18-6.78-1.14-10.23-1.09-5.2.08-11.78-.1-16.98-.02-5.2-.08-11.78.1-16.98.02-3.45-.05-6.98-.09-10.23,1.09-4.26,1.55-7.61,5.07-9.98,9.01-5.03,8.4-6.08,18.6-7,28.42-1.12,11.94-2.24,30.09-3.37,42.02h95.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m888.09,397.47c1.06-11.24,2.11-22.47,3.17-33.71.87-9.24,1.85-18.85,6.59-26.76,2.23-3.72,5.38-7.03,9.39-8.49,3.06-1.11,6.39-1.07,9.63-1.02,4.9.08,11.09-.09,15.99-.02,4.9-.08,11.09.09,15.99.02,3.25-.05,6.57-.09,9.63,1.02,4.01,1.46,7.16,4.77,9.39,8.49,4.74,7.91,5.72,17.51,6.59,26.76,1.06,11.24,2.11,22.47,3.17,33.71h-89.55Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m1080.52,397.47c-1.12-11.94-2.24-30.09-3.37-42.02-.92-9.82-1.97-20.02-7-28.42-2.37-3.95-5.72-7.47-9.98-9.01-3.25-1.18-6.78-1.14-10.23-1.09-5.2.08-11.78-.1-16.98-.02-5.2-.08-11.78.1-16.98.02-3.45-.05-6.98-.09-10.23,1.09-4.26,1.55-7.61,5.07-9.98,9.01-5.03,8.4-6.08,18.6-7,28.42-1.12,11.94-2.24,30.09-3.37,42.02h95.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "m988.18,397.47c1.06-11.24,2.11-22.47,3.17-33.71.87-9.24,1.85-18.85,6.59-26.76,2.23-3.72,5.38-7.03,9.39-8.49,3.06-1.11,6.39-1.07,9.63-1.02,4.9.08,11.09-.09,15.99-.02,4.9-.08,11.09.09,15.99.02,3.25-.05,6.57-.09,9.63,1.02,4.01,1.46,7.16,4.77,9.39,8.49,4.74,7.91,5.72,17.51,6.59,26.76,1.06,11.24,2.11,22.47,3.17,33.71h-89.55Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "m1180.61,397.47c-1.12-11.94-2.24-30.09-3.37-42.02-.92-9.82-1.97-20.02-7-28.42-2.37-3.95-5.72-7.47-9.98-9.01-3.25-1.18-6.78-1.14-10.23-1.09-5.2.08-11.78-.1-16.98-.02-5.2-.08-11.78.1-16.98.02-3.45-.05-6.98-.09-10.23,1.09-4.26,1.55-7.61,5.07-9.98,9.01-5.03,8.4-6.08,18.6-7,28.42-1.12,11.94-2.24,30.09-3.37,42.02h95.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m1088.27,397.47c1.06-11.24,2.11-22.47,3.17-33.71.87-9.24,1.85-18.85,6.59-26.76,2.23-3.72,5.38-7.03,9.39-8.49,3.06-1.11,6.39-1.07,9.63-1.02,4.9.08,11.09-.09,15.99-.02,4.9-.08,11.09.09,15.99.02,3.25-.05,6.57-.09,9.63,1.02,4.01,1.46,7.16,4.77,9.39,8.49,4.74,7.91,5.72,17.51,6.59,26.76,1.06,11.24,2.11,22.47,3.17,33.71h-89.55Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m1280.7,397.47c-1.12-11.94-2.24-30.09-3.37-42.02-.92-9.82-1.97-20.02-7-28.42-2.37-3.95-5.72-7.47-9.98-9.01-3.25-1.18-6.78-1.14-10.23-1.09-5.2.08-11.78-.1-16.98-.02-5.2-.08-11.78.1-16.98.02-3.45-.05-6.98-.09-10.23,1.09-4.26,1.55-7.61,5.07-9.98,9.01-5.03,8.4-6.08,18.6-7,28.42-1.12,11.94-2.24,30.09-3.37,42.02h95.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m1188.36,397.47c1.06-11.24,2.11-22.47,3.17-33.71.87-9.24,1.85-18.85,6.59-26.76,2.23-3.72,5.38-7.03,9.39-8.49,3.06-1.11,6.39-1.07,9.63-1.02,4.9.08,11.09-.09,15.99-.02,4.9-.08,11.09.09,15.99.02,3.25-.05,6.57-.09,9.63,1.02,4.01,1.46,7.16,4.77,9.39,8.49,4.74,7.91,5.72,17.51,6.59,26.76,1.06,11.24,2.11,22.47,3.17,33.71h-89.55Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m831.29,438.59c-1.12-11.94-3.21-42.48-4.33-54.42-.92-9.82-1.97-20.02-7-28.42-2.37-3.95-5.72-7.47-9.98-9.01-3.25-1.18-6.78-1.14-10.23-1.09-5.2.08-11.78-.1-16.98-.02-5.2-.08-11.78.1-16.98.02-3.45-.05-6.98-.09-10.23,1.09-4.26,1.55-7.61,5.07-9.98,9.01-5.03,8.4-6.08,18.6-7,28.42-1.12,11.94-3.26,42.48-4.38,54.42h97.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m737.32,438.59c1.06-11.24,2.77-34.87,3.83-46.1.87-9.24,1.85-18.85,6.59-26.76,2.23-3.72,5.38-7.03,9.39-8.49,3.06-1.11,6.39-1.07,9.63-1.02,4.9.08,11.09-.09,15.99-.02,4.9-.08,11.09.09,15.99.02,3.24-.05,6.57-.09,9.63,1.02,4.01,1.46,7.16,4.77,9.39,8.49,4.74,7.91,5.72,17.51,6.59,26.76,1.06,11.24,2.72,34.87,3.78,46.1h-90.83Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m731.2,438.59c-1.12-11.94-3.21-42.48-4.33-54.42-.92-9.82-1.97-20.02-7-28.42-2.37-3.95-5.72-7.47-9.98-9.01-3.25-1.18-6.78-1.14-10.23-1.09-5.2.08-11.78-.1-16.98-.02-5.2-.08-11.78.1-16.98.02-3.45-.05-6.98-.09-10.23,1.09-4.26,1.55-7.61,5.07-9.98,9.01-5.03,8.4-6.08,18.6-7,28.42-1.12,11.94-3.26,42.48-4.38,54.42h97.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m637.23,438.59c1.06-11.24,2.77-34.87,3.83-46.1.87-9.24,1.85-18.85,6.59-26.76,2.23-3.72,5.38-7.03,9.39-8.49,3.06-1.11,6.39-1.07,9.63-1.02,4.9.08,11.09-.09,15.99-.02,4.9-.08,11.09.09,15.99.02,3.24-.05,6.57-.09,9.63,1.02,4.01,1.46,7.16,4.77,9.39,8.49,4.74,7.91,5.72,17.51,6.59,26.76,1.06,11.24,2.72,34.87,3.78,46.1h-90.83Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m631.11,438.59c-1.12-11.94-3.21-42.48-4.33-54.42-.92-9.82-1.97-20.02-7-28.42-2.37-3.95-5.72-7.47-9.98-9.01-3.25-1.18-6.78-1.14-10.23-1.09-5.2.08-11.78-.1-16.98-.02-5.2-.08-11.78.1-16.98.02-3.45-.05-6.98-.09-10.23,1.09-4.26,1.55-7.61,5.07-9.98,9.01-5.03,8.4-6.08,18.6-7,28.42-1.12,11.94-3.26,42.48-4.38,54.42h97.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "m537.14,438.59c1.06-11.24,2.77-34.87,3.83-46.1.87-9.24,1.85-18.85,6.59-26.76,2.23-3.72,5.38-7.03,9.39-8.49,3.06-1.11,6.39-1.07,9.63-1.02,4.9.08,11.09-.09,15.99-.02,4.9-.08,11.09.09,15.99.02,3.25-.05,6.57-.09,9.63,1.02,4.01,1.46,7.16,4.77,9.39,8.49,4.74,7.91,5.72,17.51,6.59,26.76,1.06,11.24,2.72,34.87,3.78,46.1h-90.83Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m531.02,438.59c-1.12-11.94-3.21-42.48-4.33-54.42-.92-9.82-1.97-20.02-7-28.42-2.37-3.95-5.72-7.47-9.98-9.01-3.25-1.18-6.78-1.14-10.23-1.09-5.2.08-11.78-.1-16.98-.02-5.2-.08-11.78.1-16.98.02-3.45-.05-6.98-.09-10.23,1.09-4.26,1.55-7.61,5.07-9.98,9.01-5.03,8.4-6.08,18.6-7,28.42-1.12,11.94-3.26,42.48-4.38,54.42h97.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "m437.05,438.59c1.06-11.24,2.77-34.87,3.83-46.1.87-9.24,1.85-18.85,6.59-26.76,2.23-3.72,5.38-7.03,9.39-8.49,3.06-1.11,6.39-1.07,9.63-1.02,4.9.08,11.09-.09,15.99-.02,4.9-.08,11.09.09,15.99.02,3.25-.05,6.57-.09,9.63,1.02,4.01,1.46,7.16,4.77,9.39,8.49,4.74,7.91,5.72,17.51,6.59,26.76,1.06,11.24,2.72,34.87,3.78,46.1h-90.83Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m931.35,438.59c-1.12-11.94-3.21-42.48-4.33-54.42-.92-9.82-1.97-20.02-7-28.42-2.37-3.95-5.72-7.47-9.98-9.01-3.25-1.18-6.78-1.14-10.23-1.09-5.2.08-11.78-.1-16.98-.02-5.2-.08-11.78.1-16.98.02-3.45-.05-6.98-.09-10.23,1.09-4.26,1.55-7.61,5.07-9.98,9.01-5.03,8.4-6.08,18.6-7,28.42-1.12,11.94-3.26,42.48-4.38,54.42h97.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m837.39,438.59c1.06-11.24,2.77-34.87,3.83-46.1.87-9.24,1.85-18.85,6.59-26.76,2.23-3.72,5.38-7.03,9.39-8.49,3.06-1.11,6.39-1.07,9.63-1.02,4.9.08,11.09-.09,15.99-.02,4.9-.08,11.09.09,15.99.02,3.25-.05,6.57-.09,9.63,1.02,4.01,1.46,7.16,4.77,9.39,8.49,4.74,7.91,5.72,17.51,6.59,26.76,1.06,11.24,2.72,34.87,3.78,46.1h-90.83Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m1031.47,438.59c-1.12-11.94-3.21-42.48-4.33-54.42-.92-9.82-1.97-20.02-7-28.42-2.37-3.95-5.72-7.47-9.98-9.01-3.25-1.18-6.78-1.14-10.23-1.09-5.2.08-11.78-.1-16.98-.02-5.2-.08-11.78.1-16.98.02-3.45-.05-6.98-.09-10.23,1.09-4.26,1.55-7.61,5.07-9.98,9.01-5.03,8.4-6.08,18.6-7,28.42-1.12,11.94-3.26,42.48-4.38,54.42h97.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m937.5,438.59c1.06-11.24,2.77-34.87,3.83-46.1.87-9.24,1.85-18.85,6.59-26.76,2.23-3.72,5.38-7.03,9.39-8.49,3.06-1.11,6.39-1.07,9.63-1.02,4.9.08,11.09-.09,15.99-.02,4.9-.08,11.09.09,15.99.02,3.24-.05,6.57-.09,9.63,1.02,4.01,1.46,7.16,4.77,9.39,8.49,4.74,7.91,5.72,17.51,6.59,26.76,1.06,11.24,2.72,34.87,3.78,46.1h-90.83Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "m1131.55,438.59c-1.12-11.94-3.21-42.48-4.33-54.42-.92-9.82-1.97-20.02-7-28.42-2.37-3.95-5.72-7.47-9.98-9.01-3.25-1.18-6.78-1.14-10.23-1.09-5.2.08-11.78-.1-16.98-.02-5.2-.08-11.78.1-16.98.02-3.45-.05-6.98-.09-10.23,1.09-4.26,1.55-7.61,5.07-9.98,9.01-5.03,8.4-6.08,18.6-7,28.42-1.12,11.94-3.26,42.48-4.38,54.42h97.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m1037.58,438.59c1.06-11.24,2.77-34.87,3.83-46.1.87-9.24,1.85-18.85,6.59-26.76,2.23-3.72,5.38-7.03,9.39-8.49,3.06-1.11,6.39-1.07,9.63-1.02,4.9.08,11.09-.09,15.99-.02,4.9-.08,11.09.09,15.99.02,3.24-.05,6.57-.09,9.63,1.02,4.01,1.46,7.16,4.77,9.39,8.49,4.74,7.91,5.72,17.51,6.59,26.76,1.06,11.24,2.72,34.87,3.78,46.1h-90.83Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "m1231.65,438.59c-1.12-11.94-3.21-42.48-4.33-54.42-.92-9.82-1.97-20.02-7-28.42-2.37-3.95-5.72-7.47-9.98-9.01-3.25-1.18-6.78-1.14-10.23-1.09-5.2.08-11.78-.1-16.98-.02-5.2-.08-11.78.1-16.98.02-3.45-.05-6.98-.09-10.23,1.09-4.26,1.55-7.61,5.07-9.98,9.01-5.03,8.4-6.08,18.6-7,28.42-1.12,11.94-3.26,42.48-4.38,54.42h97.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m1137.68,438.59c1.06-11.24,2.77-34.87,3.83-46.1.87-9.24,1.85-18.85,6.59-26.76,2.23-3.72,5.38-7.03,9.39-8.49,3.06-1.11,6.39-1.07,9.63-1.02,4.9.08,11.09-.09,15.99-.02,4.9-.08,11.09.09,15.99.02,3.24-.05,6.57-.09,9.63,1.02,4.01,1.46,7.16,4.77,9.39,8.49,4.74,7.91,5.72,17.51,6.59,26.76,1.06,11.24,2.72,34.87,3.78,46.1h-90.83Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "m1331.74,438.59c-1.12-11.94-3.21-42.48-4.33-54.42-.92-9.82-1.97-20.02-7-28.42-2.37-3.95-5.72-7.47-9.98-9.01-3.25-1.18-6.78-1.14-10.23-1.09-5.2.08-11.78-.1-16.98-.02-5.2-.08-11.78.1-16.98.02-3.45-.05-6.98-.09-10.23,1.09-4.26,1.55-7.61,5.07-9.98,9.01-5.03,8.4-6.08,18.6-7,28.42-1.12,11.94-3.26,42.48-4.38,54.42h97.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "m1237.77,438.59c1.06-11.24,2.77-34.87,3.83-46.1.87-9.24,1.85-18.85,6.59-26.76,2.23-3.72,5.38-7.03,9.39-8.49,3.06-1.11,6.39-1.07,9.63-1.02,4.9.08,11.09-.09,15.99-.02,4.9-.08,11.09.09,15.99.02,3.24-.05,6.57-.09,9.63,1.02,4.01,1.46,7.16,4.77,9.39,8.49,4.74,7.91,5.72,17.51,6.59,26.76,1.06,11.24,2.72,34.87,3.78,46.1h-90.83Z"
  }))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeatro);
export default __webpack_public_path__ + "static/media/teatro.969c1708efd3fdd811fd36565b04bc07.svg";
export { ForwardRef as ReactComponent };